import { useEffect, useState } from "react";
import { useAuth } from "@/hooks/useAuth";
import { API_URL } from "@/config";
import axios from "axios";

const http = axios.create({ baseURL: API_URL, withCredentials: true });

interface Lead {
    cust_leadid: number;
    cust_fname: string;
    cust_lname: string;
    cust_email: string;
    cust_phoneno: string | null;
    cust_lead_type: string | null;
    cust_lead_source: string | null;
    cust_comment: string | null;
    cust_status: string | null;
    cust_lead_created_at: string | null;
}

export default function SalesLeadsPage() {
    const { user } = useAuth();
    const dealerId = Number(user?.dealerId ?? 0);
    const spId = user?.id;

    const [leads, setLeads] = useState<Lead[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!dealerId || !spId) return;
        http.get<Lead[]>(`/leads/${dealerId}`, { params: { salespersonId: spId } })
            .then(r => setLeads(r.data))
            .catch(() => setLeads([]))
            .finally(() => setLoading(false));
    }, [dealerId, spId]);

    return (
        <div className="p-6 space-y-4">
            <h1 className="text-2xl font-light uppercase tracking-wide">My Leads</h1>

            {loading ? (
                <p className="text-sm text-gray-400">Loading leads...</p>
            ) : leads.length === 0 ? (
                <p className="text-sm text-gray-400">No leads assigned to you.</p>
            ) : (
                <div className="bg-white rounded-2xl shadow overflow-hidden">
                    <table className="w-full text-sm">
                        <thead className="text-xs uppercase text-gray-400 bg-gray-50 border-b">
                            <tr>
                                <th className="text-left px-4 py-3">Name</th>
                                <th className="text-left px-4 py-3">Email</th>
                                <th className="text-left px-4 py-3">Phone</th>
                                <th className="text-left px-4 py-3">Type</th>
                                <th className="text-left px-4 py-3">Source</th>
                                <th className="text-left px-4 py-3">Status</th>
                                <th className="text-left px-4 py-3">Date</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-50">
                            {leads.map(l => (
                                <tr key={l.cust_leadid} className="hover:bg-gray-50">
                                    <td className="px-4 py-3 font-medium">{l.cust_fname} {l.cust_lname}</td>
                                    <td className="px-4 py-3 text-gray-500">{l.cust_email}</td>
                                    <td className="px-4 py-3">{l.cust_phoneno ?? "—"}</td>
                                    <td className="px-4 py-3">{l.cust_lead_type ?? "—"}</td>
                                    <td className="px-4 py-3">{l.cust_lead_source ?? "—"}</td>
                                    <td className="px-4 py-3">
                                        <span className="px-2 py-0.5 rounded-full text-xs bg-indigo-100 text-indigo-700">
                                            {l.cust_status ?? "NEW"}
                                        </span>
                                    </td>
                                    <td className="px-4 py-3 text-gray-400">
                                        {l.cust_lead_created_at ? new Date(l.cust_lead_created_at).toLocaleDateString() : "—"}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}
